module.exports = __webpack_public_path__ + "static/Coloring-Sheet-1-c8bb78c511c6199631017fbb13a7204b.jpg";